import RestModel from "../../utils/RestModel.js";
import HeweconUserBase from "./HeweconUserBase";

export default new RestModel(HeweconUserBase, "UserDto", "user-dto");
